var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transitional_page"},[_c('img',{staticClass:"shareImg",attrs:{"src":_vm.shareImg,"alt":""}}),_c('div',{staticClass:"now_apply",on:{"click":_vm.goSharePage}},[_vm._v("立即申请")])])}
var staticRenderFns = []

export { render, staticRenderFns }